import {
  REQUEST_CAMPAIGN,
  RECEIVE_CAMPAIGN,
  ADD_CAMPAIGN,
  RECEIVE_ADDED_CAMPAIGN,
  FAILURE_ADDED_CAMPAIGN,
  SEND_EMAIL,
  RECEIVE_RESPONSE,
  RECEIVE_INFLUENCERS_CAMPAIGN,
  RESET_RESPONSE,
} from "./CampaignActions";

const _nullData = {
  loading: false,
  campaign: {
    currentBrandName: "",
    myProducts: [],
    myBrands: [],
    competitionProducts: [],
    competitionBrands: [],
    existingCampaigns: [],
  },
  loadingCampaign: false,
  data: {
    mailCampaign: {},
  },
  loadingResponse: false,
  response: {
    sentMail: false,
  },
  influencersCampaign: {},
};

export default (state = _nullData, payload = {}) => {
  const { data, type, campaign, response, influencersCampaign } = payload;
  switch (type) {
    case REQUEST_CAMPAIGN:
      return { ...state, loading: true };
    case RECEIVE_CAMPAIGN:
      return { ...state, campaign, loading: false };
    case ADD_CAMPAIGN:
      return { ...state, loadingCampaign: true };
    case FAILURE_ADDED_CAMPAIGN:
      return { ...state, loadingCampaign: false };
    case RECEIVE_ADDED_CAMPAIGN:
      return {
        ...state,
        data,
        loadingCampaign: false,
        campaign: {
          ...state.campaign,
          existingCampaigns: [
            ...state.campaign.existingCampaigns,
            data.mailCampaign,
          ],
        },
      };
    case SEND_EMAIL:
      return { ...state, loadingResponse: true };
    case RECEIVE_RESPONSE:
      return { ...state, response, loadingResponse: false };
    case RESET_RESPONSE:
      return { ...state, response: { sentMail: false } };
    case RECEIVE_INFLUENCERS_CAMPAIGN:
      return { ...state, influencersCampaign };
    default:
      return state;
  }
};
